(function() {
  function updateCookieBannerText() {
    const bannerBody = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body');
    if (!bannerBody) return;

    const p = bannerBody.querySelector('p');
    if (!p || p.getAttribute('data-custom-text-applied')) return;

    const link = p.querySelector('a');
    const linkHref = link ? link.getAttribute('href') : '/policies/privacy-policy';
    
    // Update the paragraph content while keeping the link
    p.innerHTML = `We and our partners use cookies to personalise your experience and perform analytics. Learn more in our <a id="shopify-pc__banner__body-policy-link" href="${linkHref}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.`;
    
    // Mark as applied to prevent infinite loops if something else triggers a change
    p.setAttribute('data-custom-text-applied', 'true');
  }

  // Use MutationObserver to detect when the banner is added to the DOM
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        if (document.querySelector('#shopify-pc__banner')) {
          updateCookieBannerText();
          // We could disconnect here, but Shopify might re-render it if settings change, 
          // so maybe keep it watching or disconnect once it's solid.
          // For now, let's keep it to ensure it stays updated.
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also try running it immediately in case it's already there
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCookieBannerText);
  } else {
    updateCookieBannerText();
  }
})();
